import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=0f81544c&"
import script from "./groups.vue.js?vue&type=script&lang=js&"
export * from "./groups.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports